<template>

  <div class="ad_bottom">

    <!-- footer AD -->
    <div class="ad_wrap footer">
      <div class="inner">

        <display-container :section="103" empty-bg-color="transparent">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
          </template>
        </display-container>

        <!-- PC -->
        <!--<ins class="adsbygoogle"
        style="display:block"
        data-ad-client="ca-pub-5310971739125617"
        data-ad-slot="2086161536"
        data-ad-format="auto"
        data-full-width-responsive="true"></ins>-->

        <!-- M -->
        <!--<ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-5310971739125617"
         data-ad-slot="4085068091"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>-->

        <!--<Adsense v-bind:ad-slot="2086161536"></Adsense>-->

      </div>
    </div>

    <div class="ad_wing">
      <div class="left">

        <display-container :section="104" empty-bg-color="transparent">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
          </template>
        </display-container>

        <!-- PC -->
        <!--<ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-5310971739125617"
         data-ad-slot="4304559947"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>-->

        <Adsense v-bind:ad-slot="4304559947"></Adsense>

      </div>
      <div class="right">

        <display-container :section="105" empty-bg-color="transparent">
          <template v-slot="{ component, row }">
            <img :src="component.getImage(row)" :style="component.getImgSizeByStyle(row)" />
          </template>
        </display-container>

        <!-- PC -->
        <!--<ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-5310971739125617"
         data-ad-slot="4304559947"
         data-ad-format="auto"
         data-full-width-responsive="true"></ins>-->

        <Adsense v-bind:ad-slot="4304559947"></Adsense>

      </div>
    </div>

		<display-container :section="109" class="ad_wall" v-if="!isCurrentGNB('home')">
			<template v-slot="{ component, row }"></template>
		</display-container>

  </div>


</template>

<script>
  import CommonComputed from 'src/_mixins/CommonComputed'
	import CommonMethods from 'src/_mixins/CommonMethods'
  import DisplayContainer from '../components/DisplayContainer'
  import Adsense from '../components/Adsense'
  export default {
    name: 'SubFooter',
    components: {
      DisplayContainer,
      Adsense
    },
    computed: {
      ...CommonComputed,
    },
		methods: {
			...CommonMethods,
			isCurrentGNB (name) {
        return this.$route.path.indexOf(name) > -1
      },
		}
  }
</script>

<style scoped>
  .ad_bottom .ad_wrap {
    padding: 40px 0;
  }
  .ad_bottom .ad_wrap /deep/ a {
    padding: 20px 0 70px 0;
  }
  .ad_bottom .ad_wrap /deep/ a img {
    width: 728px !important;
    height: 90px !important;
  }
  .ad_wing {

  }
  .ad_wing .left {
    position: fixed;
    top: 280px;
    left: 50%;
    width: 160px;
    transform: translate(-820px, 0);
  }
  .ad_wing .right {
    position: fixed;
    top: 280px;
    left: 50%;
    width: 160px;
    transform: translate(660px, 0);
  }
	/* on wallpaper */
	.wallpaper .ad_bottom .ad_wrap {
		margin: 0 auto;
		padding: 75px 0;
	}
	.ad_wall {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: #000;
		z-index: -1;
	}
	/deep/ .ad_wall a {
		position: fixed;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	/deep/ .ad_wall a > div {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}
	/deep/ .ad_wall a > div > img {
		position: fixed;
		width: 2500px !important;
		height: 1080px !important;
		left: 50%;
		transform: translate(-50%, 0);
	}
</style>
